export default {
      id: "arrow-download-usage",
      viewBox: "0 0 16 25",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow-download",
      toString: function () {
        return this.url;
      }
    }